<ng-container>
  <div class="flex flex-col text-darkGray">
    <span class="text-[20px] font-semibold">Upload New QRIS</span>
    <span class="text-[14px] text-[#667085]"
      >Add QRIS codes to your collection</span
    >
  </div>

  <div class="flex flex-col lg:flex-row gap-6 mt-6 w-full">
    <!-- Left Column: Upload & Input -->
    <div class="flex flex-col gap-6 w-full lg:w-1/2">
      <!-- Upload Area -->
      <div class="flex flex-col gap-2">
        <span class="text-[16px] font-semibold text-[#101828]">QRIS Image</span>
        <nz-upload
          nzType="drag"
          [nzMultiple]="false"
          [nzFileList]="fileList"
          [nzBeforeUpload]="beforeUpload"
          (nzChange)="handleChange($event)"
          [nzShowUploadList]="false"
          class="qris-uploader"
        >
          <div class="flex items-center flex-col gap-2 p-6">
            <img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/export-2.svg"
              alt="upload"
              class="w-10 opacity-70"
            />
            <span class="text-[14px]">
              <span class="text-[#0F679A] font-bold">Click to upload</span>
              <span class="text-[#667085]"> or drag and drop </span>
            </span>
            <span class="text-[12px] text-[#667085]">
              PNG, JPG up to 5 mb
            </span>
          </div>
        </nz-upload>
      </div>

      <!-- Input Area -->
      <div class="flex flex-col gap-2">
        <span class="text-[16px] font-semibold text-[#101828]">QRIS Name</span>
        <input
          nz-input
          [(ngModel)]="qrisName"
          maxlength="100"
          placeholder="Enter a descriptive name"
          class="rounded-lg h-11"
        />
        <span class="text-[12px] text-[#667085]">
          Choose the name that helps you to identify your QRIS
        </span>
      </div>
    </div>

    <!-- Right Column: Preview -->
    <div class="flex flex-col gap-2 w-full lg:w-1/2">
      <span *ngIf="fileList.length > 0" class="text-[16px] font-semibold text-[#101828]">File Preview</span>
      <div
        *ngIf="fileList.length === 0"
        class="flex flex-col items-center justify-center border-2 border-dashed border-[#EAECF0] rounded-xl min-h-[280px] bg-[#F9FAFB] p-4 relative"
      >
        <!-- Empty State -->
        <div class="flex flex-col items-center gap-2">
          <img
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/gallery.svg"
            alt="gallery"
            class="w-10 opacity-70"
          />
          <span class="text-[#667085] text-[14px]"
            >Select a file to see preview</span
          >
        </div>
      </div>
      <!-- File Selected State -->
      <div
        *ngIf="fileList.length > 0"
        class="w-full h-full flex flex-col"
      >
        <div
            class="flex items-center gap-3 p-2 bg-white border-2 border-[#EAECF0] border-dashed rounded-lg"
          >
            <div class="p-2 rounded-lg">
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/gallery.svg"
                alt="upload"
                class="w-10"
              />
            </div>
            <span class="text-[14px] font-medium text-[#344054] truncate">{{
              fileList[0].name
            }}</span>
          </div>

          <div class="flex justify-end items-center gap-3 mt-3">
            <button
              nz-button
              nzType="text"
              (click)="handleRemove(fileList[0])"
              class="text-[#667085] h-10"
            >
              Delete
            </button>
            <button
              nz-button
              nzType="primary"
              (click)="onUpload()"
              class="h-10 px-6"
            >
              Upload QR
            </button>
          </div>
        </div>
    </div>
  </div>
</ng-container>
